import _ from 'lodash';
import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const SLEEP_RECORDS_LIST_SUCCESS =
  api.events.sleepRecordsList.actionSuccess;
const SLEEP_RECORDS_LATEST_SUCCESS = 
  api.events.sleepRecordsLatest.actionSuccess;
const SLEEP_RECORDS_CREATE_SUCCESS =
  api.events.sleepRecordsPost.actionSuccess;
const SLEEP_RECORDS_PATCH_SUCCESS =
  api.events.sleepRecordsPatch.actionSuccess;
const SLEEP_RECORDS_DELETE_SUCCESS =
  api.events.sleepRecordsDelete.actionSuccess;

const sleepRecordSchema = new schema.Entity('sleepRecords');

const sleepRecordListSchema = new schema.Array(sleepRecordSchema);

const defaultState = {};

export default function(state = defaultState, action) {
  switch (action.type) {
    case SLEEP_RECORDS_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, sleepRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.sleepRecords
      };
    }
    case SLEEP_RECORDS_LATEST_SUCCESS: {
      const normalizedData = normalize(action.data, sleepRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.sleepRecords
      };
    }
    case SLEEP_RECORDS_CREATE_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case SLEEP_RECORDS_PATCH_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case SLEEP_RECORDS_DELETE_SUCCESS: {
      const deletedId = action.request.pathvars.id;
      return _.omit(state, [deletedId]);
    }
    case LOGOUT_SUCCESS:
      return defaultState;
    default:
      return state;
  }
}
